// extracted by mini-css-extract-plugin
export default {"Box":"x-axis-selector-module__Box--EMNF9"};